export default {
  title: 'Obiekt',
  type: 'object',
  properties: {
    city: {
      title: 'Miasto',
      type: 'string',
      fieldRequired: false
    },
    postalCode: {
      title: 'Kod pocztowy',
      type: 'string',
      format: 'kod',
      fieldRequired: false,
      validationMessages: {
        format: 'Niepoprawny kod pocztowy'
      }
    },
    street: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: false
    },
    homeNumber: {
      type: 'string',
      fieldRequired: false
    },
    localNumber: {
      type: 'string',
      fieldRequired: false
    },

    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'Opis*',
      type: 'string',
      fieldRequired: true
    },
    images: {
      title: 'Pozostałe obrazki',
      type: 'string',
      default: ''
    },
    mainImage: {
      title: 'Obrazek tła',
      type: 'number'
    },
    descriptionShort: {
      type: 'string',
      maxLength: 500,
      fieldRequired: false
    },
    lat: {
      type: 'string',
      fieldRequired: false
    },
    lng: {
      type: 'string',
      fieldRequired: false
    }
  }
};
